export const THEME_LANG_DOMAIN = 'apothekehart';